import loadinggif from "../../../assets/load.gif";
import { loginRequest } from "../../../authConfig";
import { useMsal } from "@azure/msal-react";
import { useState } from "react";

const Attachment = ({ attachments }) => {
  const ApiDomain = import.meta.env.VITE_BACKEND_API_HOST;
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const viewDoc = (e) => {
    console.log("viewDoc");
    getInstance();
  };
  const getInstance = async () => {
    setIsLoading(true);
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        getFile(response);
      })
      .catch((error) => {
        instance
          .acquireTokenPopup({
            ...loginRequest,
            account: accounts[0],
          })
          .then((response) => {
            getFile(response);
            console.log(error);
          });
      });
  };

  async function getFile(response) {
    let filename = "";
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);
    const options = {
      method: "GET",
      headers: headers,
    };
    let url = `https://${ApiDomain}/ora/get/attachment?wono=${attachments.WO_NO}&docNo=${attachments.DOC_NO}`;
    console.log(`1 URL: ${url}`);
    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const disposition = response.headers.get("Content-Disposition");
        filename = disposition.split(/\*=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace(/utf-8''/i, ""));
        else filename = filename.replace(/['"]/g, "");
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setIsLoading(false);
      });
    console.log("END");
  }

  return (
    <div className="divFileContainer">
      <div className="divFileName">
        {attachments.FILETITLE}
        {attachments.FILETYPE.toLowerCase()}
      </div>
      <div className="divFileButton">
        <button className="btn" onClick={viewDoc}>
          Visa
        </button>
      </div>
    </div>
  );
};

export default Attachment;
